import { Component } from '@angular/core';
import { environment } from '../environments/environment';
import { GetCourseTreeObject } from './stores/usercourseTreeobject.store';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./app.component.scss'],

})
export class AppComponent {
  title = 'app works!';
  categories;
  courses: any;
  lessons: any;
  constructor(private getCourseTreeObject: GetCourseTreeObject) {
    this.getCourseTreeObject.categories;
    console.log(environment);


  }
}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/app.component.ts